import { type User } from '@scoring/types';
import { useApiMutation } from '../../queries/useApiMutation';
import { produce } from 'immer';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { del } from '../../queries';

export const useDeleteUserMutation = () => {
    const mutation = useApiMutation<{ id: string }>({
        mutationFn: ({ id }) => del(`users/${id}`, undefined),
        onManualCacheUpdate: (queryClient, _response, args) => {
            setQueryDataSafe<User[]>(queryClient, queryKeys.users.list(), (previous) =>
                produce(previous, (draft) => {
                    const index = draft.findIndex((u) => u.id === args.id);
                    if (index !== -1) draft.splice(index, 1);
                })
            );
        },
    });

    return mutation;
};
